export default "__VITE_ASSET__7dd3b981__"